import { KeyRound, Palette } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const settings = defineDashboardModule({
  id: "settings",
  nav: [
    {
      group: "System",
      title: "Branding",
      to: "/settings/branding",
      icon: Palette,
    },
    {
      group: "System",
      title: "Integrations",
      to: "/settings/integrations",
      icon: KeyRound,
    },
  ],
  routes: [
    {
      path: "/settings/branding",
      component: lazyPage(() => import("./routes/branding"), "BrandingPage"),
    },
    {
      path: "/settings/integrations",
      component: lazyPage(
        () => import("./routes/integrations"),
        "IntegrationsPage"
      ),
    },
    {
      path: "/settings/integrations/:id",
      component: lazyPage(
        () => import("./routes/integration-detail"),
        "IntegrationDetailPage"
      ),
    },
  ],
})
